export default "__VITE_ASSET__CaF52pAv__"